import { useStore } from "../store/Store";
import ProductCard from "../components/ProductCard";
import Footer from "../components/Footer";

export default function WishlistPage({ onNav }) {
  const { wish, products } = useStore();
  const wishedProds = products.filter(p => wish.includes(p.id));

  return (
    <div style={{ background:"white", paddingTop:64, minHeight:"100vh" }}>
      <div style={{ background:"linear-gradient(135deg,#1a1a2e,#2d1b69)", padding:"24px clamp(16px,4vw,40px)" }}>
        <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(22px,4vw,36px)", fontWeight:900, color:"white" }}>
          My Wishlist <span style={{ color:"#EC4899", fontStyle:"italic" }}>({wishedProds.length})</span>
        </h1>
      </div>

      <div style={{ padding:"28px clamp(16px,4vw,40px)", minHeight:"60vh" }}>
        {wishedProds.length === 0 ? (
          <div style={{ textAlign:"center", padding:"80px 20px" }}>
            <div style={{ fontSize:64, marginBottom:16 }}>🤍</div>
            <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:24, fontWeight:900, color:"#1a1a2e", marginBottom:12 }}>Nothing saved yet</h2>
            <p style={{ fontSize:13, color:"#999", marginBottom:24 }}>Tap the heart icon on products you love!</p>
            <button onClick={()=>onNav("shop")}
              style={{ background:"#EC4899", color:"white", border:"none", padding:"13px 32px", borderRadius:50, fontSize:14, fontWeight:700, cursor:"pointer" }}>
              Browse Products
            </button>
          </div>
        ) : (
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(clamp(140px,22vw,220px),1fr))", gap:"clamp(10px,2vw,20px)" }}>
            {wishedProds.map(p => <ProductCard key={p.id} p={p} onNav={onNav} />)}
          </div>
        )}
      </div>
      <Footer onNav={onNav} />
    </div>
  );
}
